import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './SpecificDaysPicker.styles';

type Props = {
  value?: Date[];
  onChange?: (value: Date[]) => void;
  hideLabel?: boolean;
};

export const SpecificDaysPicker: React.FC<Props> = ({ value, onChange, hideLabel }) => {
  const { t } = useTranslation('DefaultTranslations');
  return (
    <Wrapper>
      {!hideLabel && <p>{t('SPECIFIC_DAYS')}</p>}
      <DatePicker
        maxTagCount={4}
        multiple
        value={value}
        onChange={onChange}
        format="DD/MM/YYYY"
        minDate={dayjs().startOf('day')}
      />
    </Wrapper>
  );
};
